export default "__VITE_ASSET__a967b86b__"